import { isPublicHttpUrl, PUBLIC_HTTP_URL_ERROR } from "../utils/safe-url";

type ContextInput = {
  data?: Record<string, unknown>;
  ui?: Record<string, unknown>;
};

function resolveLinkUrl(value: string): string {
  return value.startsWith("http://") || value.startsWith("https://")
    ? value
    : `https://${value}`;
}

function widgetType(
  ui: Record<string, unknown> | undefined,
  field: string
): string | undefined {
  const fieldUi = ui?.[field];
  if (typeof fieldUi !== "object" || fieldUi === null) {
    return undefined;
  }
  const widget = (fieldUi as Record<string, unknown>)["ui:widget"];
  return typeof widget === "string" ? widget : undefined;
}

function validateUrlValue(value: unknown, widget: string): string | null {
  if (widget === "image" || widget === "link") {
    if (typeof value !== "string") {
      return PUBLIC_HTTP_URL_ERROR;
    }
    const url = widget === "link" ? resolveLinkUrl(value) : value;
    if (!isPublicHttpUrl(url)) {
      return PUBLIC_HTTP_URL_ERROR;
    }
    return null;
  }

  if (widget === "attachments" && Array.isArray(value)) {
    for (const item of value) {
      if (typeof item !== "object" || item === null) {
        continue;
      }
      const url = (item as { url?: unknown }).url;
      if (typeof url === "string" && !isPublicHttpUrl(resolveLinkUrl(url))) {
        return PUBLIC_HTTP_URL_ERROR;
      }
    }
  }

  return null;
}

/**
 * Validates URL-bearing context widget values (image, link, attachments).
 * Returns an error message or null when valid.
 */
export function validateContextPublicUrls(
  context: ContextInput | undefined
): string | null {
  if (!context?.data) {
    return null;
  }

  for (const [field, value] of Object.entries(context.data)) {
    const widget = widgetType(context.ui, field);
    if (!widget) {
      continue;
    }
    const error = validateUrlValue(value, widget);
    if (error) {
      return `context.data.${field}: ${error}`;
    }
  }

  return null;
}
